import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import neascafe from "../../../../../assets/images/OUR SERVICES/Nescafe.png";
import amigo from "../../../../../assets/images/OUR SERVICES/Nescafe-Amigo.png";
import spectra from "../../../../../assets/images/OUR SERVICES/nescafe-spectra.jpg";
import solution from "../../../../../assets/images/OUR SERVICES/Nescafe-Solutions.png";
import neascafelogo from "../../../../../assets/images/OUR SERVICES/nescafemachines.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const CoffeeMachine = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Nescafe Coffee Machines</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={12} md={12} className="text-center">
                                    <img
                                        src={neascafelogo}
                                        alt="Nescafe Logo"
                                        className="img-fluid rounded"
                                        style={{ width: "200PX", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12} className="text-center">
                                    <img src={neascafe} alt="FRIO Coffee Vending Machine" className="img-fluid rounded" style={{ width: "100%", height: "auto" }} />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>FRIO Coffee Vending Machine</h3>
                                    <p className="text-black"><strong>Fresh & Aromatic Coffee</strong> – Enjoy premium-quality coffee at the touch of a button.</p>
                                    <p className="text-black"><strong>Multiple Beverage Choices</strong> – Serves coffee, tea, and other specialty drinks.</p>
                                    <p className="text-black"><strong>Fast & Convenient</strong> – Ideal for offices, cafes, and public spaces.</p>
                                    <p className="text-black"><strong>Touchless Payments</strong> – Supports digital transactions for a seamless experience.</p>
                                    <p className="text-black"><strong>Easy Maintenance</strong> – Quick refilling and automated cleaning.</p>
                                    <p className="text-black"><strong>Energy-Efficient Design</strong> – Eco-friendly and power-saving technology.</p>
                                    <p className="text-black"><strong>Beverages</strong> – Cappuccino, Espresso, Latte, Black Coffee, Hot Chocolate, Masala Tea, Cardamom Tea, Green Tea, Lemon Tea.</p>
                                </Col>


                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>AMIGO Coffee Vending Machine</h3>
                                    <p className="text-black"><strong>Barista-Style Coffee Anytime</strong> – Brew high-quality coffee with a rich aroma and perfect taste.</p>
                                    <p className="text-black"><strong>Versatile Beverage Selection</strong> – Enjoy a variety of coffee, tea, and specialty drinks.</p>
                                    <p className="text-black"><strong>Designed for High Performance</strong> – Serves multiple cups efficiently, ideal for busy workplaces and hospitality spaces.</p>
                                    <p className="text-black"><strong>Hassle-Free Operation</strong> – Simple interface with automated brewing for convenience.</p>
                                    <p className="text-black"><strong>Low Maintenance & Durable</strong> – Built with an easy-to-clean system and long-lasting components.</p>
                                    <p className="text-black"><strong>Beverages Available</strong> – Cappuccino, Espresso, Latte, Black Coffee, Hot Chocolate, Masala Tea, Cardamom Tea, Green Tea, Lemon Tea.</p>
                                </Col>
                                <Col lg={6} md={12} className="text-center">
                                    <img src={amigo} alt="AMIGO Coffee Vending Machine" className="img-fluid rounded" style={{ width: "100%", height: "auto" }} />
                                </Col>

                                <Col lg={6} md={12} className="text-center">
                                    <img src={solution} alt="NESCAFÉ  SOLUTION Coffee Vending Machine" className="img-fluid rounded" style={{ width: "100%", height: "auto" }} />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>NESCAFÉ  SOLUTION Coffee Vending Machine</h3>
                                    <p className="text-black"><strong>Perfect Coffee, Every Time</strong> – Delivers a consistently rich and flavorful coffee experience.</p>
                                    <p className="text-black"><strong>Wide Beverage Variety</strong> – Enjoy a selection of premium coffee, tea, and other hot drinks.</p>
                                    <p className="text-black"><strong>Ideal for High-Demand Areas</strong> – Designed for offices, cafes, hotels, and retail spaces.</p>
                                    <p className="text-black"><strong>User-Friendly Operation</strong> – Simple interface for quick and easy beverage dispensing.</p>
                                    <p className="text-black"><strong>Effortless Maintenance</strong> – Features automated cleaning and easy refilling for hassle-free use.</p>
                                    <p className="text-black"><strong>Eco-Conscious & Efficient</strong> – Built with energy-saving technology for sustainable operations.</p>
                                    <p className="text-black"><strong>Beverages Available</strong> – Cappuccino, Espresso, Latte, Black Coffee, Hot Chocolate, Masala Tea, Cardamom Tea, Green Tea, Lemon Tea.</p>
                                </Col>


                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>SPECTRA Coffee Vending Machine</h3>
                                    <p className="text-black"><strong>Advanced Brewing Technology</strong> – Ensures a smooth, barista-quality coffee experience with every cup.</p>
                                    <p className="text-black"><strong>Perfect for Diverse Workspaces</strong> – Ideal for offices, coworking spaces, lounges, and conference rooms.</p>
                                    <p className="text-black"><strong>Touchless Operation</strong> – Contactless dispensing for hygiene and convenience.</p>
                                    <p className="text-black"><strong>AI-Enabled Smart Features</strong> – Tracks usage, monitors stock levels, and provides maintenance alerts.</p>
                                    <p className="text-black"><strong>Eco-Friendly & Energy Efficient</strong> – Optimized power consumption with auto-sleep mode.</p>
                                    <p className="text-black"><strong>Beverages Available</strong> – Americano, Mocha, Filter Coffee, Hazelnut Latte, Caramel Macchiato, Ginger Tea, Tulsi Tea, Lemon Honey Tea.</p>
                                </Col>
                                <Col lg={6} md={12} className="text-center">
                                    <img src={spectra} alt="Spectra Coffee Vending Machine" className="img-fluid rounded" style={{ width: "100%", height: "auto" }} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default CoffeeMachine;